import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import HeadLineComponent from './HeadLineComponent';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import images from './images/images';
import back from './images/back-arrow/back-arrow.svg';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import {dwhEnterUpdatePayment} from './dwhReports';
import {gaReportOnButtonClick} from './gaReports';

const WelcomeToUpdatePaymentMethodComponent = ({props, setSelectedForUpdate, backToLobby}) => {
  if (props.data.currentStep !== 1) {
    return null;
  }
  const isBusinessBlock = props.cmsData?.isBusinessBlock?.value || false;
  useExtendedEffect((runSideEffects) => {
    // if (runSideEffects()) {
    if (!isBusinessBlock) {
      continueToUpdate();
    } else {
      dwhEnterUpdatePayment(true);
    }
    // }
  }, []);

  const [animateOut, setAnimateOut] = useState(false);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects() && !props.data.isLoading && isBusinessBlock) {
        setTimeout(() => {
          props.saveToHistory();
        }, 500);
      }
    },
    [props.data.isLoading],
  );

  //animation
  useEffect(() => {
    if (props.data.selectedForUpdate && props.data.submitAnimation) {
      setAnimateOut(true);
      setTimeout(() => {
        props.handleCurrentStep(3);
      }, props.data.animationTimeOut);
    }
  }, [props.data.selectedForUpdate]);

  const continueToUpdate = () => {
    if (!isBusinessBlock) {
      const data = {idNumber: props.IdNumber, selectedProvider: 'Cellcom', isPrivateUserFlow: true};
      props.getOrgPaymentMethodList(data);
    } else {
      gaReportOnButtonClick('welcome_page_continue_to_the_next_step_btn');
    }

    if (props.data.orgDetailList.length > 0) {
      if (props.data.orgDetailList.length != 1 && !props.selectedFromPortal && props.data.submitAnimation) {
        setAnimateOut(true);
        setTimeout(() => {
          props.handleCurrentStep(2);
        }, props.data.animationTimeOut);
      } else {
        let orgList = props.data.orgDetailList;
        if (props.selectedFromPortal) {
          orgList = props.data.orgDetailList.filter((org) => org.idNumber == props.selectedFromPortal);
        }

        orgList.map((org) => {
          if ((org.cellInd && org.netvInd) || (!org.cellInd && !org.netvInd)) {
            props.handleCurrentStep(2);
          } else {
            if (org.cellInd && org.bussinesContactRole.isActionAllowedCellcom) {
              setSelectedForUpdate(org.idNumber, 'Cellcom');
            } else {
              if (org.bussinesContactRole.isActionAllowedNv) {
                setSelectedForUpdate(org.idNumber, 'Netvision');
              }
            }
          }
        });
      }
    }
  };

  return (
    <>
      {!props.data.isLoading && isBusinessBlock && (
        <div className={`${animateOut ? 'animateOut' : 'animateIn'}`}>
          <HeadLineComponent text={'לעדכן כרטיס אשראי או הוראת קבע בקלות ובמהירות'} />
          <Container className='text-center step-one'>
            <Row>
              <Col>
                <p className='mb-0 headline-text-description'>
                  אם הגעתם כדי להגדיר הוראת קבע חדשה, חשוב לוודא שיש לכם טופס הוראת קבע חתום על ידי הבנק
                </p>
                <a
                  onClick={backToLobby}
                  className='purple-text back-link d-block w-100 p-2'
                  accessKey='s'
                  title='Back to previous page'
                  style={{'--open-close-button-bg': back.bg()}}>
                  <span>אין לי, אחזור פעם אחרת</span>
                </a>
              </Col>
            </Row>
            <Row>
              <Col className='welcome-image'>
                <Image src={images.welcome} alt='welcome to update invoices' />
              </Col>
            </Row>
            <Row>
              <Col xs={12} className={`${props.data.orgDetailList.length == 0 && isBusinessBlock ? 'disabled-btn' : ''} btn-290 btn-row`}>
                <BtnSubmit isBusiness={isBusinessBlock} text='אוקיי, אפשר להמשיך' onclick={() => continueToUpdate()} />
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
};

export default WelcomeToUpdatePaymentMethodComponent;
